import { useNavigate, useParams } from 'react-router-dom';

/** The printed card, full screen, with a way out of it.
 *
 * The card used to open in a new tab. In a browser that is fine; in the
 * installed app it is a trap, because a standalone PWA has no back button and
 * the only way home is a system gesture nobody thinks of while holding a
 * knife. So the card gets a page of its own, with a bar across the top.
 *
 * `?download=1` is a separate URL rather than the same one with a `download`
 * attribute: the attribute is ignored for a cross-document navigation on iOS,
 * and the server saying `Content-Disposition: attachment` is not.
 */
export default function RecipeCard() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div className="card-view">
      <header className="card-view__bar">
        {/* -1 rather than a route, so this returns to whichever page opened
            the card. Falls back to the recipe when there is no history to go
            back to — a cold load straight onto this URL. */}
        <button
          className="card-view__close"
          aria-label="Close the recipe card"
          onClick={() => (window.history.length > 1 ? navigate(-1) : navigate(`/recipes/${id}`))}
        >
          ✕
        </button>
        <span className="card-view__title">Recipe card</span>
        <a className="btn btn--small" href={`/api/recipes/${id}/pdf/?download=1`}>
          Download
        </a>
      </header>
      <object
        className="card-view__doc"
        data={`/api/recipes/${id}/pdf/`}
        type="application/pdf"
        aria-label="The printed recipe card"
      >
        {/* Reached when the browser will not render a PDF inline, which is the
            usual outcome on iOS. Opening it is then the honest offer. */}
        <div className="card-view__fallback">
          <p className="muted">This browser won’t show the card inline.</p>
          <a className="btn btn--primary" href={`/api/recipes/${id}/pdf/`} target="_blank" rel="noreferrer">
            Open the card
          </a>
        </div>
      </object>
    </div>
  );
}
